import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useActionInput } from '../../../context';
import { Validation, ValidationError } from '../../../lib/validation';

export const useErrorText = () => {
	const { t } = useTranslation('action_input');
	const { validator } = useActionInput();

	return useCallback(
		(error: ValidationError) => {
			if (error.id === Validation.ServerError) {
				return error.data as string;
			}

			if (error.id === Validation.MissingRequiredHashtag) {
				let tags: string[] = [];

				if (validator && Array.isArray(validator.requireHashtag)) {
					tags = validator.requireHashtag;
				}

				return t(`validation.${error.id}`, {
					tags: tags.map((tag) => `#${tag}`),
				});
			}

			return t(`validation.${error.id}`);
		},
		[t, validator]
	);
};
